import React from "react";
import "./HomeExpect.scss";

const homeExpectationItems = [
  {
    title: "User-centered Approach",
    description:
      "We prioritize users, conducting thorough research to create designs that resonate, enhancing engagement and fostering lasting connections.",
  },
  {
    title: "Data-Informed Decisions",
    description:
      "We leverage user behavior insights, aligning design choices with data for optimal usability and impactful user interactions.",
  },
  {
    title: "Holistic Strategy",
    description:
      "We unify UX, UI, and functionality seamlessly, crafting designs that authentically reflect your brand, delivering holistic and cohesive experiences.",
  },
  {
    title: "Tailored Solutions",
    description:
      "We delve into user personas, forging custom solutions to address specific challenges, ensuring designs align precisely with user need.",
  },
  {
    title: "Timely Delivery",
    description:
      "Our streamlined workflows and strategic planning ensure projects are delivered promptly, adhering to your timelines without compromise.",
  },
  {
    title: "Long Term Viability",
    description:
      "With in-depth foresight, we design for longevity, anticipating trends and changes, which results in sustained relevance and minimized need for constant updates.",
  },
];

const HomeExpect = () => {
  return (
    <section className="section homeExpect">
      <article className="homeExpect__container container">
        <div className="homeExpect__container--title">
          <h3 className="homeExpect__title">WHAT TO EXPECT</h3>
        </div>
        <div className="homeExpect__container--contents">
          {homeExpectationItems.map((item, index) => (
            <div className="homeExpect__container--contents-items" key={index}>
              <h3 className="contents-items-title">{item.title}</h3>
              <p className="contents-items-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </article>
    </section>
  );
};

export default HomeExpect;
